export default __webpack_public_path__ + "static/fili-nustar-new-f2554e3db92b0e74a4bf57a21691bb1d.jpg";